import { Component, input } from '@angular/core';
import { RdsDividerModule, RdsIconsModule, RdsLinkModule} from '@rds/angular-components';

@Component({
  selector: 'inexp-knowledge-technical-resources',
  imports: [RdsLinkModule, RdsIconsModule, RdsDividerModule],
  templateUrl: './knowledge-technical-resources.component.html',
  styleUrl: './knowledge-technical-resources.component.scss',
})
export class KnowledgeTechnicalResourcesComponent {
  _uid = input<string>();
  component = input<string>();
  knowledgeSection = input<string>();
  technicalResources = input<any[]>();
  hasPublishedItems(): boolean {
    return this.technicalResources()?.some(b => b.published === true) ?? false;
  }
}
